import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=60956e1e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=60956e1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60956e1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60956e1e')) {
      api.createRecord('60956e1e', component.options)
    } else {
      api.reload('60956e1e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=60956e1e&scoped=true&", function () {
      api.rerender('60956e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-259WRgZTUzYWy/JS/comp/PopupBox.vue"
export default component.exports